import ProductDetailsModal from "./product-details/index";

export default ProductDetailsModal;
